import { ReactNode } from 'react';
import { IconX, IconInfoCircle } from '@tabler/icons-react';

interface Props {
	title: string;
	isOpen: boolean;
	toggleTooltip: () => void;
	children: ReactNode;
}

export const OverlaidTooltip = ({ title, isOpen, toggleTooltip, children }: Props) => {
	const iconElement = isOpen ? (
		<IconX stroke={2} size={24} className="mr-1" />
	) : (
		<IconInfoCircle stroke={2} size={24} className="mr-1" />
	);

	return (
		<div className="relative inline-block">
			<div
				onClick={toggleTooltip}
				className="flex items-center cursor-pointer rounded bg-gray-100 p-3"
			>
				{iconElement}
				<div className="font-bold">{title}</div>
			</div>
			{isOpen && (
				<div className="absolute rounded bg-gray-100 p-3 mb-2 w-[460px] shadow-md right-0 bottom-full">
					{children}
				</div>
			)}
		</div>
	);
};
